// extracted by mini-css-extract-plugin
module.exports = {"hashtag":"text_hashtag__lBTgg","userTag":"text_userTag__hI6p7"};